import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { handleFieldChange, 
  getUser, 
  resetUser,
  changePassword } from '../../../store/actions/users/usersActions';
import PageTitle from '../../../common/PageTitle';
import PasswordStrengthMeter from '../../../components/settings/users/PasswordStrengthMeter';

class ChangePasswordForm extends Component {

  constructor() {
    super();
    this.state = {
      new_password: '',
      errors: ''
    }
    this.onChangeConfirmPassword = this.onChangeConfirmPassword.bind(this);
  }

  onChangeConfirmPassword(e) {
    let errors = '';
    this.setState({ confirm_password: e.target.value });

    if(this.state.new_password !== e.target.value){
      errors = "Passwords don't match.";
    }
    else{
      errors = "";
    }

    this.setState({
      errors: errors
    });
  }

  componentDidMount() {
    window.scroll(0, 0);
    const pathname = this.props.location.pathname;
    if (pathname === '/users/change-password') {
        this.action = 'CHANGE_PASSWORD';
        this.props.resetUser();
    }

    this.submitButtonText = "Submit";
  }

  componentWillUnmount() {
    this.props.resetUser();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.beforeSubmit();

    if (this.action === "CHANGE_PASSWORD") {
      this.props.changePassword(
        () => { this.props.history.push('/users/change-password'); },
        this.afterSubmit
      );
    }
  }

  beforeSubmit = (selector = "") => {
    if (!selector) {
      selector = "button[type='submit']";
    }
    const submitButton = document.querySelector(selector);
    if (submitButton) {
      submitButton.disabled = true;
      if (this.submitButtonText === 'Update') {
        submitButton.textContent = "updating...";
      }
    }
  }

  afterSubmit = (selector = "") => {
    if (!selector) {
      selector = "button[type='submit']";
    }
    const submitButton = document.querySelector(selector);
    if (submitButton) {
      submitButton.disabled = false;
        if (this.submitButtonText === 'Update') {
          submitButton.textContent = "Updated!";
        }
        setTimeout(() => {  
          submitButton.textContent = this.submitButtonText;
        }, 1000);
    }
  }

  render() {
    let formTitle = 'Change Password';

    this.submitButtonText = 'Update';

    if (this.action === "CHANGE_PASSWORD") {
      this.submitButtonText = 'Update';
      formTitle = 'Change Password';
    }

    const new_password = this.state.new_password;

    return (
      <>
        <PageTitle pageName={formTitle} />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="current_password">
                    <Form.Label>Current Password</Form.Label>
                    <Form.Control type="password" onChange={this.props.handleFieldChange} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="new_password">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      onChange={ this.props.handleFieldChange }
                      onKeyUp={ e => this.setState({ new_password: e.target.value }) }
                    />
                    <PasswordStrengthMeter new_password = { new_password } />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <Form.Group controlId="confirm_password">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      onChange={ this.onChangeConfirmPassword.bind(this) }
                    />
                    <label className="password-match-error-label">{ this.state.errors }</label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <div className="align-right">
                    <Button variant="default" onClick={() => {
                        this.props.history.push('/dashboard');
                      }}>Cancel</Button> 
                    <Button variant="primary" type="submit" disabled={ this.state.new_password !== this.state.confirm_password } >{this.submitButtonText}</Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleFieldChange: (...args) =>  dispatch(handleFieldChange(...args)),
    changePassword: (...args) => dispatch(changePassword(...args)),
    getUser: (...args) => dispatch(getUser(...args)),
    resetUser: () => dispatch(resetUser())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePasswordForm))
